export default "__VITE_ASSET__2PKRqVrZ__"